import React from "react";
import "./style.scss";
import ReviewDetail from "../../../components/Review/ReviewDetail";

const ReviewDetailPage = () => {
  return (
    <div className="review_detail_page">
      <ReviewDetail />
    </div>
  );
};

export default ReviewDetailPage;
